import { DataTrackingType, SocialType } from '@hhgtech/hhg-components/types'
import { AspectRatio, Box, BoxProps } from '@mantine/core'

import { ZaloSharing } from 'components/atoms/zaloSharing'
import { useCurrentUrl } from 'hooks/useCurrentUrl'

import useStyles from './index.styles'
import { SocialItem as SocialItem } from '../types'

type Props = {
  social: SocialItem
  iconSize?: number
  touchSize?: number
  bgZaloColor?: string // Trick to cover origin zalo icon
  zaloLayout?: number
} & Partial<BoxProps> &
  DataTrackingType

export const SocialItemEle = ({
  social,
  iconSize = 28,
  touchSize = 36,
  styles,
  classNames,
  bgZaloColor = '#fff',
  zaloLayout,
  dataEventAction,
  ...rest
}: Props) => {
  const { classes } = useStyles(
    {
      iconSize,
      touchSize,
      isZalo: social.type === SocialType.Zalo,
      bgZaloColor,
    },
    {
      name: 'ShareBox--SocialItem',
      styles,
      classNames,
    },
  )
  const currentUrl = useCurrentUrl()
  return (
    <Box
      component={social.type !== SocialType.Zalo ? 'a' : 'div'}
      {...{
        target: '_blank',
        href: social.href,
        className: 'pointer-event-child-none',
        'data-event-category': 'Social Share',
        'data-event-action': dataEventAction,
        'data-event-label': currentUrl,
      }}
      {...rest}
    >
      <AspectRatio className={classes.item} ratio={1}>
        <Box>
          <Box className={classes.itemInner}>{social.icon}</Box>
          {social.type === SocialType.Zalo && (
            <>
              <Box className={classes.zaloOverlay} />
              <ZaloSharing
                href={social.href}
                layout={zaloLayout}
                sx={{
                  pointerEvents: 'auto',
                }}
              />
            </>
          )}
        </Box>
      </AspectRatio>
    </Box>
  )
}
